import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMyBetsPlinkoService, placeBetPlinkoGameService,
  postLightningBoardDetailsService
} from 'games/Plinko/services/plinkoGame.service'
import {
  fastModeBox, pixiCancelBall, pixiCreateBall, pixiStartMovingBall
} from 'games/Plinko/GameTheme/PlinkoGame/pixi-js-scripts/bridge'
import { enqueueCreditWalletWaitQueue, debitBalance, dequeueCreditWalletWaitQueue } from 'redux-store/redux/slices/auth.slice'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { appendMyBetsPlinko, setBetLock } from 'games/Plinko/slices-thunks/plinkoGame.slice'
import { generateClientSeed } from 'utils/common-functions/index'
import { pixiSetAutoBet } from '../GameTheme/PyramidPlinkoGame/pixi-js-scripts/bridge'

export const placedBetPlinkoGame = createAsyncThunk('plinko-game/place-bet',
  async ({ payload, id, fastMode, autoBet = false }, thunkApi) => {
    try {
      const res = await placeBetPlinkoGameService(payload)
      // Deducting the balance from the main balance after the bet is placed successfully
      thunkApi.dispatch(debitBalance(res?.betAmount))
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(res?.winningAmount))
      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }
      if (fastMode) {
        fastModeBox(res.dropDetails)
        thunkApi.dispatch(setBetLock())
        thunkApi.dispatch(appendMyBetsPlinko())
      } else {
        const lastBall = res?.dropDetails.length
        pixiSetAutoBet(autoBet)
        pixiStartMovingBall(res.dropDetails)
        pixiCreateBall(lastBall, res.winningAmount)
      }
      return res
    } catch (error) {
      if (!fastMode) {
        pixiCancelBall()
      }
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsPlinko = createAsyncThunk('plinko-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsPlinkoService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const postLightningBoardDetails = createAsyncThunk('plinko-game/post-lightning-board-details', async (params, thunkApi) => {
  try {
    const res = await postLightningBoardDetailsService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description)
  }
})
